import * as React from 'react';
import {TextareaHTMLAttributes} from 'react';

import {Label} from '../Label';

import {TextareaContainer, TextareaElem} from './styled';

interface Props extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    hasError?: boolean;
    label?: string;
    formFieldName?: string;
}

export function Textarea(props: Props) {
    const {className, label, disabled = false, hasError, ...otherProps} = props;

    return (
        <TextareaContainer className={className}>
            <Label text={label} hasError={hasError}>
                <TextareaElem hasError={hasError} disabled={disabled} {...otherProps} />
            </Label>
        </TextareaContainer>
    );
}
